import { render } from "./supplementModel.vue?vue&type=template&id=4b0ee994"
import script from "./supplementModel.vue?vue&type=script&lang=js"
export * from "./supplementModel.vue?vue&type=script&lang=js"

import "./supplementModel.vue?vue&type=style&index=0&id=4b0ee994&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__